import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink, Facebook, Instagram, Youtube } from 'lucide-react';
import { APP_CONFIG } from '../../config/appConfig';
import { useBrandConfig } from '../../context/BrandConfigContext';

const Footer = () => {
  const brand = useBrandConfig();
  const logoSrc = brand?.logoUrl || '/assets/images/app-logo/coca-cola-white.png';

  // Build social links from brand config (falls back to APP_CONFIG)
  const socialLinks = [
    brand?.social?.facebook  && { name: 'Facebook',  icon: Facebook,  url: brand.social.facebook  },
    brand?.social?.instagram && { name: 'Instagram', icon: Instagram, url: brand.social.instagram },
    brand?.social?.youtube   && { name: 'YouTube',   icon: Youtube,   url: brand.social.youtube   },
  ].filter(Boolean);
  const socialMediaLinks = socialLinks.length > 0 ? socialLinks : APP_CONFIG.socialMedia.map(s => ({ ...s, icon: { Facebook, Instagram, Youtube }[s.icon] }));

  // const campaignName = brand?.campaign?.name || APP_CONFIG.campaign.name;
  const campaignDesc = brand?.campaign?.description || APP_CONFIG.campaign.description;
  const copyrightText = brand?.footer_copyright || 'All rights reserved.';
  const year = new Date().getFullYear();

  const quickLinks = [
    { label: 'FAQs', to: '/faqs', external: false },
    brand?.legal?.privacyPolicyUrl
      ? { label: 'Privacy', to: brand.legal.privacyPolicyUrl, external: true }
      : { label: 'Privacy', to: 'https://www.coca-cola.com/ng/en/legal/privacy-policy', external: true }
  ];

  const legalLinks = [
    { label: 'Terms & Conditions', to: brand?.legal?.termsUrl || APP_CONFIG.legal.terms, external: !brand?.legal?.termsUrl?.startsWith('/') },
    { label: 'Cookie Policy',      to: brand?.legal?.cookiePolicyUrl || APP_CONFIG.legal.cookiePolicy, external: true }
  ];

  return (
    <footer className="footer-wrapper  strict-width">
      <div className="container strict-width">
        {/* Brand Section */}
        <div className="card border-0 rounded-4 mb-2" style={{ background: '#00000029', backdropFilter: 'blur(10px)' }}>
          <div className="card-body text-center p-4">
            <div className="mb-2">
              <img src={logoSrc} alt="App Logo" style={{ height: '42px', objectFit: 'contain' }} />
            </div>
            {/* <h6 className="fw-bold text-white mb-2">{campaignName}</h6> */}
            <p
              className="text-white mb-3"
              style={{ fontSize: '0.85rem', lineHeight: '1.4' }}
              dangerouslySetInnerHTML={{ __html: campaignDesc }}
            ></p>

            <div className="row">
              <div className="col-6">
                {/* <h6 className="fw-bold text-white mb-3" style={{ fontSize: '0.9rem' }}>Quick Links</h6> */}
                <div className="d-flex flex-column gap-2 align-items-end text-end">
                  {quickLinks.map((link) =>
                    link.external ? (
                      <a
                        key={link.label}
                        href={link.to}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="d-flex align-items-center gap-1 text-decoration-none text-white flex-row-reverse"
                        style={{ fontSize: '0.8rem', transition: 'color 0.3s ease' }}
                      >
                        <span>{link.label}</span>
                        <ExternalLink size={12} />
                      </a>
                    ) : (
                      <Link
                        key={link.label}
                        to={link.to}
                        className="d-flex align-items-center gap-1 text-decoration-none text-white flex-row-reverse"
                        style={{ fontSize: '0.8rem', transition: 'color 0.3s ease' }}
                      >
                        <span>{link.label}</span>
                      </Link>
                    )
                  )}
                </div>
              </div>
              <div className="col-6">
                <div className="d-flex flex-column gap-2">
                  {legalLinks.map((link) =>
                    link.external ? (
                      <a
                        key={link.label}
                        href={link.to}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="d-flex align-items-center gap-1 text-decoration-none text-white"
                        style={{ fontSize: '0.8rem', transition: 'color 0.3s ease' }}
                      >
                        <span>{link.label}</span>
                        <ExternalLink size={12} />
                      </a>
                    ) : (
                      <Link
                        key={link.label}
                        to={link.to}
                        className="d-flex align-items-center gap-1 text-decoration-none text-white"
                        style={{ fontSize: '0.8rem', transition: 'color 0.3s ease' }}
                      >
                        <span>{link.label}</span>
                      </Link>
                    )
                  )}
                </div>
              </div>
            </div>

            {/* Social Media Icons */}
            <div className="d-flex justify-content-center gap-3 mt-4 mb-2">
              {socialMediaLinks.map((social) => {
                const IconComponent = social.icon;
                return (
                  <a
                    key={social.name}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-media-icon"
                    aria-label={social.name}
                  >
                    <IconComponent size={18} />
                  </a>
                );
              })}
            </div>
          </div>
        </div>

        {/* Copyright Card */}
        <div className="card border-0 rounded-4 mb-3" style={{ background: '#00000029', backdropFilter: 'blur(10px)' }}>
          <div className="card-body text-center p-4">
            <p className="mb-1 text-white" style={{ fontSize: '0.75rem' }}>
              © {year} {copyrightText}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
